import { render } from "./RedPack.vue?vue&type=template&id=82bdba94&scoped=true"
import script from "./RedPack.vue?vue&type=script&lang=js"
export * from "./RedPack.vue?vue&type=script&lang=js"

import "./RedPack.vue?vue&type=style&index=0&id=82bdba94&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82bdba94"]])

export default __exports__